import React from "react";
import { useTranslation } from "react-i18next";
import PostCard from "../common/PostCard";

const EmptyFeed = ({ t }) => (
  <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
    <div className="text-gray-400 mb-4">
      <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 9a2 2 0 012-2m0 0V5a2 2 0 012 2v2M7 7h10" />
      </svg>
    </div>
    <h3 className="text-xl font-semibold text-gray-900 mb-2">{t("feed.noPostsYet")}</h3>
    <p className="text-gray-600">{t("feed.beFirstToShare")}</p>
  </div>
);

const LoadMoreButton = ({ onLoadMore, isLoading, t }) => (
  <div className="text-center mt-8">
    <button
      onClick={onLoadMore}
      disabled={isLoading}
      className="px-8 py-3 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isLoading ? (
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
          <span>{t("common.loading")}</span>
        </div>
      ) : (
        t("feed.loadMorePosts")
      )}
    </button>
  </div>
);

const FeedPostsList = ({ 
  posts, 
  currentUser,
  onLike,
  onComment,
  onDelete,
  comment,
  setComment,
  activeCommentPost,
  setActiveCommentPost,
  hasNextPage,
  isFetchingNextPage,
  loadMore,
  commentMutation,
  likePostMutation,
  deletePostMutation,
  isLiking,
  isCommenting
}) => {
  const { t } = useTranslation();
  
  if (posts.length === 0) {
    return <EmptyFeed t={t} />;
  }

  return (
    <div className="space-y-6">
      {posts.map((post) => (
        <PostCard
          key={post.postId || post._id || post.id}
          post={post}
          currentUser={currentUser}
          onLike={onLike}
          onComment={onComment}
          onDelete={onDelete}
          comment={comment}
          setComment={setComment}
          activeCommentPost={activeCommentPost}
          setActiveCommentPost={setActiveCommentPost}
          commentMutation={commentMutation}
          likePostMutation={likePostMutation}
          deletePostMutation={deletePostMutation}
          isLiking={isLiking}
          isCommenting={isCommenting}
        />
      ))}

      {/* Load More Button */}
      {hasNextPage && (
        <LoadMoreButton onLoadMore={loadMore} isLoading={isFetchingNextPage} t={t} />
      )}
    </div>
  );
};

export default FeedPostsList; 